import { Injectable } from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {delay, finalize, map} from 'rxjs/operators';

import {CONTENT_TYPE_JSON_UTF8, WORD_API_IN_URL, } from '../../defines/protocol';
import {HISTORY_KEY_VIEW_WORD, SearchParam} from '../../defines/client.const';
import {ListLoader} from '../../interfaces/list-loader';
import {SimpleWord} from '../../models/simple-word.model';
import {SearchHistory} from '../../models/history.model';
import {ApiService} from '../api/api.service';


@Injectable({
  providedIn: 'root'
})
export class WordHistoryService implements ListLoader<SimpleWord> {

  private history: SearchHistory;

  constructor(
    private api: ApiService,
  ) {
    this.history = new SearchHistory({name: HISTORY_KEY_VIEW_WORD});
  }

  public addHistory(id: string): void {
    if (!id) {
      console.error('WordHistoryService::addHistory() invalid id', id);
    }
    else {
      this.history.addItem(id);
    }
  }

  /******************************************************************************
   * ListLoader<Word> 구현부
   *****************************************************************************/

    // TODO: 일단 페이지 없이 모두 로딩한다. 나중에 페이지 로딩 추가해야 함.
  // private nextPage: number;
  private listWord: Array<SimpleWord> | null = null;
  private mapWord: Map<string, SimpleWord> | null = null;
  private load$: Observable<boolean> | null = null;

  public getList(): Array<SimpleWord> | null {
    return this.listWord;
  }

  public getCurCount(): number | null {
    console.log('WordHistoryService::getCurCount()');
    return this.listWord?.length ?? null;
  }

  public getTotalCount(): number | null {
    // console.log('WordHistoryService::getTotalCount()');
    return this.history.size;
  }

  public IsComplete(): boolean {
    // console.log('WordHistoryService::IsComplete()');
    return this.listWord?.length === this.history.size ||
      this.history.empty();
  }

  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  public getById(id: string): SimpleWord | null {
    return this.mapWord?.get(id) ?? null;
  }

  public ResetList(param?: SearchParam): void {
    // console.log('WordHistoryService::ResetList()', param, this);
    this.listWord = null;
    this.mapWord = null;

    // this.nextPage = 0;
    if (param?.id) {
      this.addHistory(param.id);
    }
  }

  public GetNextList(): Observable<boolean> {
    console.log('WordHistoryService::GetNextList()', this);
    // 이미 다 로딩 했는지 확인
    // if (this.history.listHistory.length < this.nextPage * HISTORY_PAGE_SIZE) {
    if (this.IsComplete()) {
      return throwError({message: 'already load all words in bookmark'});
    }
    else if (this.history.empty()) {
      // 이력이 없으면 서버에 요청하지 않고 처리한다.
      return new Observable<boolean>(observer => {
        observer.next(false);
        observer.complete();
      }).pipe(delay(0));
    }

    if (this.load$) {
      return this.load$;
    }

    const url = WORD_API_IN_URL;
    return this.load$ = this.api.Post(url, {list: this.history.list}, null, CONTENT_TYPE_JSON_UTF8).pipe(
      finalize(() => {
        this.load$ = null;
      }),
      map((data: []) => {
        // if (this.nextPage === 0) {
        this.listWord = new Array<SimpleWord>();
        this.mapWord = new Map<string, SimpleWord>();
        // }
        data.forEach(value => {
          if (this.listWord === null || this.mapWord === null) {
            throw new Error('WordHistoryService::GetNextList() - listWord or mapWord is null');
          }

          const word = new SimpleWord(value);
          this.listWord.push(word);
          this.mapWord.set(word.id, word);
        });

        if (this.listWord.length !== this.history.size) {
          console.error('WordHistoryService::GetNextList() - invalid received list size', this.listWord, this.history.list);
        }

        // return this.nextPage++ === 0;
        return true;
      })
    );
  }
}
